import React from 'react';
import styled from 'styled-components';
import { Theme } from '@routific/hive';
import PendingChangesChip from '../PendingChangesChip';

interface Props {
  title: React.ReactNode;
  showPendingChanges: boolean;
  /** When false, chip is icon-only (Gantt). Defaults to labeled. */
  chipWithLabel?: boolean;
  className?: string;
}

const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
  gap: ${Theme.Spacing.smSpacing};
`;

const TitleSlot = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

const ChipSlot = styled.div`
  flex: 0 0 auto;
`;

/** Title + trailing Pending changes chip. Shared by list cards and details header. */
const RouteTitleWithPendingChanges: React.FC<Props> = ({
  title,
  showPendingChanges,
  chipWithLabel = true,
  className,
}) => (
  <Row className={className} data-testid="route-title-with-pending-changes">
    <TitleSlot>{title}</TitleSlot>
    <ChipSlot>
      <PendingChangesChip show={showPendingChanges} withLabel={chipWithLabel} />
    </ChipSlot>
  </Row>
);

export default RouteTitleWithPendingChanges;
